import React from 'react';
import styled from 'styled-components';
import Typography from 'kingpin/atoms/Typography';
import { ReactComponent as SearchIcon } from '../images/search.svg';

const WrapperDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 160px;
`;

const NoSearchInput = () => (
  <WrapperDiv>
    <div style={{ marginBottom: 16 }}>
      <SearchIcon width={64} height={64} color={'var(--color-icon-tertiary)'} />
    </div>

    <Typography.Body type="Label 14" textAlign={'center'}>
      Type something to start searching
    </Typography.Body>
  </WrapperDiv>
);

export default NoSearchInput;
